/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Swap Vert icon.
 * @export
 */
export const ICON_SWAP_VERT = (
  <svg fill="#4F4F4F" height="24" viewBox="0 -960 960 960" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M320-440v-287L217-624l-57-56 200-200 200 200-57 56-103-103v287h-80ZM600-80 400-280l57-56 103 103v-287h80v287l103-103 57 56L600-80Z" />
  </svg>
);
